import { ActionTypes } from "../type";

const initialState = {
  area_list: null,
  state_list: null,
  doctor_list: null,
  collectionType_list: null,
  franchiseTypes_list: null,
  franchise_list: null,
  payment_mode_list: null,
  investigation_list: null,
  collection_boy_list: null,
  delivery_boy_list: null,
  employee_list: null,
  zone_list: null,
  bar_code_info: null,
  receipt_info: null,
  department_list: null,
  lab_department_list: null,
  status_list: null,
  package_list: null,
  barcode_detail: null,
  franchise_package_list_dd: null,
};

export const dropListReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.AREA_LIST_DROPDOWN:
      return { ...state, area_list: action.payload };

    case ActionTypes.STATE_LIST_DROPDOWN:
      return { ...state, state_list: action.payload };

    case ActionTypes.DOCTOR_LIST_DROPDOWN:
      return { ...state, doctor_list: action.payload };

    case ActionTypes.COLLECTION_TYPE_LIST_DROPDOWN:
      return { ...state, collectionType_list: action.payload };

    case ActionTypes.FRANCHISE_TYPE_LIST_DROPDOWN:
      return { ...state, franchiseTypes_list: action.payload };

    case ActionTypes.FRANCHISE_LIST_DROPDOWN:
      return { ...state, franchise_list: action.payload };

    case ActionTypes.PAYMENT_MODE_LIST_DROPDOWN:
      return { ...state, payment_mode_list: action.payload };

    case ActionTypes.INVESTIGATION_LIST_DROPDOWN:
      return { ...state, investigation_list: action.payload };

    case ActionTypes.COLLECTION_BOY_LIST_DROPDOWN:
      return { ...state, collection_boy_list: action.payload };

    case ActionTypes.DELIVERY_BOY_LIST_DROPDOWN:
      return { ...state, delivery_boy_list: action.payload };

    case ActionTypes.EMPLOYEE_LIST_DROPDOWN:
      return { ...state, employee_list: action.payload };

    case ActionTypes.ZONE_LIST_DROPDOWN:
      return { ...state, zone_list: action.payload };

    case ActionTypes.DEPARTMENT_LIST_DROPDOWN:
      return { ...state, department_list: action.payload };

    case ActionTypes.LAB_DEPARTMENT_LIST_DROPDOWN:
      return { ...state, lab_department_list: action.payload };

    case ActionTypes.STATUS_LIST_DROPDOWN:
      return { ...state, status_list: action.payload };
    case ActionTypes.PACKAGE_LIST_DROPDOWN:
      return { ...state, package_list: action.payload };

    case ActionTypes.FRANCHISE_PACKAGE_LIST_DD_DROPDOWN:
      return { ...state, franchise_package_list_dd: action.payload };

    case ActionTypes.BAR_CODE_INFO:
      return { ...state, bar_code_info: action.payload };
    case ActionTypes.CLEAR_BAR_CODE_INFO:
      return { ...state, bar_code_info: null };
    case ActionTypes.RECEIPT_INFO:
      return { ...state, receipt_info: action.payload };

    case ActionTypes.GET_BARCODE_IMAGE:
      return { ...state, barcode_detail: action.payload };

    default:
      return state;
  }
};
